const version = '2019.11.26-21:03-46af97b';
export default version;